import { AxiosResponse } from 'axios'
import { Action } from 'redux'
import {
  call,
  CallEffect,
  ForkEffect,
  put,
  PutEffect,
  select,
  SelectEffect,
  takeLatest,
} from 'redux-saga/effects'
import { postResponse } from '../../actions/createResponse'
import { fetchWorkflow } from '../../actions/fetchWorkflowByContext'
import { loadJsonApiEntities } from '../../actions/loadJsonApiEntities'
import addViewToStore from '../../actions/views/addViewToStore'
import { WorkflowCreateResponsePayload } from '../../actions/workflow/types'
import { workflowActions } from '../../actions/workflowActions'
import workflowError from '../../actions/workflowError'

type Yield = CallEffect | SelectEffect | PutEffect
type Return = void
type Next = AxiosResponse<WorkflowCreateResponsePayload> | undefined

type Payload = {
  assignmentId: string
  entityId?: string
  details: {
    feedback?: string
    complete?: true | false
    approved?: 'approved' | 'declined'
    reasoning?: string
  }
  stageId?: string
  view: string
}

export interface ActionWithPayload extends Action {
  payload: Payload
}

export function* createResponseAndFetchWorkflow(
  action: ActionWithPayload
): Generator<Yield, Return, Next> {
  try {
    const view = yield select(
      (state) =>
        state.entityDataByView &&
        action.payload.view &&
        state.entityDataByView[action.payload.view]
    )

    if (view === undefined) {
      yield put(addViewToStore({ view: action.payload.view }))
    }

    let workflow
    const response = yield call(postResponse, {
      assignmentId: action.payload.assignmentId,
      details: action.payload.details,
    })

    if (response !== undefined) {
      yield put(loadJsonApiEntities(response.data))

      if (action.payload.entityId !== undefined) {
        workflow = yield call(fetchWorkflow, {
          id: action.payload.entityId,
          entity: 'moment',
          expose: true,
        })
      }
    }

    if (workflow !== undefined) {
      yield put(loadJsonApiEntities(workflow.data))
    }
  } catch (error) {
    console.error(error)

    yield put(
      workflowError({
        context: action.payload.stageId ? 'response' : 'workflow',
        entity: 'moment',
        error: error as Error,
        requestType: 'create',
        stageId: action.payload.stageId,
        loading: {},
      })
    )
  }
}

export function* createResponseSaga(): Generator<ForkEffect, void, void> {
  yield takeLatest(
    workflowActions.CREATE_RESPONSE,
    createResponseAndFetchWorkflow
  )
}

export default [createResponseSaga]
